import { render, staticRenderFns } from "./JobStatusBadge.vue?vue&type=template&id=fef5960c"
import script from "./JobStatusBadge.vue?vue&type=script&lang=js"
export * from "./JobStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports